import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Font2XlBold extends ITextBoxProps {}

export const TextBoxMaxLine1Font2XlBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Font2xlBold,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Font2XlBold): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
